import Vue from 'vue'
import VueGtag from "vue-gtag";
import axios from 'axios'
import Miniform from './Miniform.vue'
Vue.prototype.$http = axios

Vue.use(VueGtag, {
  config: { 
    id: "UA-177203809-1",
    params: {
      send_page_view: true
    }
  }
});

Vue.config.productionTip = false
new Vue({
  render: h => h(Miniform),
}).$mount('#miniform')
